import { getUser } from "../api/user"

export const getUserInfo = async ({uid, setUserType, setPages, navigate, allPages}) => {
    const user = await getUser(uid)
    console.log(user, "users")
    setUserType(user.role) 
    if(user.role !== 'admin' && user.role !== 'super-admin') {
        navigate('/')
    } else if(user.role === 'admin'){
        const filteredPages = allPages.filter(page => user.roles.role_features.includes(page))
        setPages(filteredPages)
    } else {
        setPages(allPages)
    }

}